import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lg:flex lg:h-full lg:flex-col" }
const _hoisted_2 = { class: "relative flex flex-wrap-reverse items-center justify-between border-b border-gray-200 md:py-4 lg:flex-none" }
const _hoisted_3 = { class: "md:text-lg md:font-semibold text-gray-900 py-2 md:py-0" }
const _hoisted_4 = ["datetime"]
const _hoisted_5 = { class: "flex items-center justify-between w-full md:w-auto" }
const _hoisted_6 = { class: "flex items-center grow-0 rounded-md shadow-sm md:items-stretch" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous month", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "relative -mx-px h-5 w-px bg-gray-300 md:hidden" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next month", -1)
const _hoisted_10 = { class: "border-l border-gray-300 lg:flex lg:flex-auto lg:flex-col" }
const _hoisted_11 = { class: "border-r border-gray-300 grid grid-cols-7 gap-px border-b border-gray-300 bg-white text-center text-xs font-semibold leading-6 lg:flex-none" }
const _hoisted_12 = { class: "sr-only sm:not-sr-only" }
const _hoisted_13 = { class: "flex text-xs text-gray-700 lg:flex-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowDownTrayIcon = _resolveComponent("ArrowDownTrayIcon")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_CalendarDayItem = _resolveComponent("CalendarDayItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createElementVNode("div", {
          datetime: String(_ctx.currentMonth)
        }, _toDisplayString(_ctx.$t(`calendar.months.${_ctx.currentMonth}.long`)) + " " + _toDisplayString(_ctx.currentYear), 9, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('bulkExport'))),
          class: "animated-button mr-2 grow border border-orange text-sm text-orange hover:bg-orange hover:text-white"
        }, [
          _createVNode(_component_ArrowDownTrayIcon, { class: "m-0 box-border block h-6 w-full shrink-0" }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("buttons.bulk_export")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "calendarPagBtn rounded-l-md border-r-0 hover:text-gray-500 focus:relative md:w-9 md:px-2 md:hover:bg-gray-50",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('prevMonth')))
          }, [
            _hoisted_7,
            _createVNode(_component_ChevronLeftIcon, {
              class: "md:w-5 w-4",
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "hidden border-b border-t border-gray-300 bg-white px-3.5 text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:relative md:block",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('resetPag')))
          }, _toDisplayString(_ctx.$t("calendar.today")), 1),
          _hoisted_8,
          _createElementVNode("button", {
            type: "button",
            class: "calendarPagBtn rounded-r-md border-l-0 hover:text-gray-500 focus:relative md:w-9 md:px-2 md:hover:bg-gray-100",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('nextMonth')))
          }, [
            _hoisted_9,
            _createVNode(_component_ChevronRightIcon, {
              class: "md:w-5 w-4",
              "aria-hidden": "true"
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, (index) => {
          return _createElementVNode("div", {
            key: index,
            class: _normalizeClass([' py-2', { 'text-gray-700': index < 7 }])
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t(`calendar.week_days.${index}.short`).charAt(0)), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(`calendar.week_days.${index}.short`).slice(1)), 1)
          ], 2)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", {
          class: _normalizeClass(["grid w-full grid-cols-7 items-stretch", `lg:grid-rows-${_ctx.weeksVisible}`])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
            return (_openBlock(), _createBlock(_component_CalendarDayItem, {
              key: day.date,
              date: day.date,
              data: day.data,
              onInitializeReport: ($event: any) => (_ctx.$emit('initializeReport', day.date)),
              onDeleteReport: ($event: any) => (_ctx.$emit('deleteReport', day.date))
            }, null, 8, ["date", "data", "onInitializeReport", "onDeleteReport"]))
          }), 128))
        ], 2)
      ])
    ])
  ]))
}